<template>
  <Card :class="$style.position">
    <img
      :class="$style.icon"
      :src="wayToAddDevice.icon"
      svg-inline
    >
    <div>
      <h4
        :class="$style.title"
        data-test-id="wayToAddDevice__title"
      >
        {{ wayToAddDevice.title }}
      </h4>
      <div :class="$style.spacing">
        <Button
          data-test-id="wayToAddDevice__addButton"
          text="add device"
          @click="redirect"
        />
        <div
          v-if="wayToAddDevice.guidedSetup"
          :class="$style.spacing"
        >
          <BDropdownDivider />
          <div :class="$style.spacing">
            <ParagraphBody bodySize="small">
              Want to see it in action? Check out our
              <Button
                :class="$style.guidedSetupButton"
                data-test-id="wayToAddDevice__guidedSetupButton"
                hasNoBackground
                :text="wayToAddDevice.guidedSetup.text"
                type="informational"
                @click="handleGuidedSetupClicked(wayToAddDevice.guidedSetup)"
              />
            </ParagraphBody>
          </div>
          <GuidedSetup
            v-if="selectedGuidedSetup"
            :defaultDevice="selectedGuidedSetup"
            setupFlow="device"
            @close="handleGuidedSetupClosed"
          />
        </div>
      </div>
    </div>
  </Card>
</template>

<script>
import {
  BDropdownDivider,
} from 'bootstrap-vue';
import {
  Button,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import { eventLocations, eventProperties } from 'client/GrowthEngineering/utilities/GrowthConstants';
import Card from 'client/components/Card.vue';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import GuidedSetup from 'client/Discover/components/GuidedSetup/GuidedSetup.vue';
import Util from 'client/util/Util';

const {
  description,
  location,
  section,
  text,
} = eventProperties;

export default {
  name: 'WayToAddDeviceCard',

  components: {
    BDropdownDivider,
    Button,
    Card,
    GuidedSetup,
    ParagraphBody,
  },

  EventHelper,

  props: {
    wayToAddDevice: {
      default: null,
      type: Object,
    },
  },

  data: () => ({
    selectedGuidedSetup: '',
  }),

  methods: {
    handleGuidedSetupClicked(guidedSetupConfig) {
      this.$options.EventHelper.triggerButtonClicked({
        [description]: `Guided Setup opened for ${guidedSetupConfig.device}`,
        [location]: eventLocations.devicesPage,
        [section]: `${this.wayToAddDevice.title} Card`,
        [text]: guidedSetupConfig.text,
      });

      this.selectedGuidedSetup = guidedSetupConfig.device;
    },

    handleGuidedSetupClosed() {
      this.selectedGuidedSetup = '';
    },

    redirect() {
      return Util.redirect(this.wayToAddDevice.redirectUrl);
    },
  },
};
</script>

<style module scoped>
@import './waysToAddDeviceCards.css';

.guidedSetupButton.guidedSetupButton {
  font-size: var(--jcBodySmall);
  font-weight: normal;
}
</style>
